var isGetCartItemFunctionCalled = false;
var customerId = "";
var getCartItemsUrl = "";
var updatedCartLineItemsAray = [];
var isCustomerLoggedIn = false;
var productAddToCartDetailObj = {};
var gaHandleAddToCartObject = {};
var isCountUpdated = false;
var cartIcon = "<span class='p-r-5'><i class='cs-font clever-icon-cart-12' ></i></span>";
var pageUrl = location.href;
var sentryLogProductHandle = "";
var sentryRequestHeaderObj = "";

var sentryResponse = {};

var homePageUrl = "https://jumkey.com/";

function getProductDetail(productHandle){
  
  customerId = $('.customer_id').val();
  
  var typeOfCustomerId = typeof(customerId);
  
  
//   this if condition is to verify is customer logged in or not
  if(typeOfCustomerId !== "string" ){
    $('#cart-count').css('visibility','hidden');
    isCustomerLoggedIn = false;
    var HistoryPageUrl = window.location.href;
    sessionStorage.setItem("historyUrl",HistoryPageUrl);
  }else{
    isCustomerLoggedIn = true;
    var isHistoryUrlExists = sessionStorage.hasOwnProperty("historyUrl");
    var historyUrl = sessionStorage.getItem("historyUrl");
    if(isHistoryUrlExists === true){
      location.assign(historyUrl);
      sessionStorage.removeItem('historyUrl');
    }
  }
  
  
//   to get cart lineitems 
  if(isGetCartItemFunctionCalled === false && isCustomerLoggedIn === true){
    getCartItemsUrl = cartBaseUrl+getCartItemsEndPoint+customerId+"?page=0&limit=250";
//     getCartItems(customerId);
  }
  
//   var productHandleUrl = "/products/"+productHandle+".js";
  
  sentryLogProductHandle = productHandle;
  
  var productHandleUrl = "https://apps.ninjaas.com:8090/api/v4/products/variants";
  let requestBodyObj = {};
  requestBodyObj["handles"] = [productHandle];
  requestBodyObj = JSON.stringify(requestBodyObj);
  
  
  $.ajax({
        type: 'POST',
        timeout: ajaxCallTimeout,
        dataType: 'json',
        contentType: 'application/json',
        error: function (request, textStatus, errorThrown) {
          
          sentryRequestHeaderObj = (request.getResponseHeader('X-Request-ID'));
          
          Sentry.configureScope(function(scope) {
            scope.setLevel('error');
            scope.setTag("Request-Id", sentryRequestHeaderObj);
          });

          Sentry.captureMessage('Error in ajax request, Request-Id '+sentryRequestHeaderObj+" Function name: getProductDetail");
          
        },
        url: productHandleUrl,
    	data:requestBodyObj,
        beforeSend: function (xhr) {
        },
        statusCode: {
            200: function (data) {
//               console.log(data,productHandle);
              sentryResponse = JSON.stringify(data);
              drawProductDetailDetail((data.products)[0]);
            },
            302: function () {
                swal({
                    title: 'Sorry',
                    text: "Session expired. Please login again.",
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            403: function () {
                swal({
                    title: 'Error!',
                    text: 'You do not have enough privilege to perform this request.' +
                    'Please contact seller support.',
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            400: function () {
                swal({
                    title: 'Invalid Input!',
                    text: 'Invalid request please check input.',
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            422: function () {
                swal({
                    title: '',
                    text: "Email id not exists",
                    type: 'warning',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            500: function () {
                swal({
                    title: 'Internal Server Error !',
                    text: 'Internal server error. We could not perform the operation this time. ' +
                    'Please try again later.',
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            }
        }
    }).fail(function(data, textStatus, xhr){
   
    console.log(data.getResponseHeader('X-Request-ID'));
    
  });
}

function getCartItems(cid){
  updatedCartLineItemsAray = [];
  
  $.ajax({
        type: 'GET',
        async:true,
        timeout: ajaxCallTimeout,
        dataType: 'json',
        contentType: 'application/json',
        headers: getV3Header(),
        error: function (request, textStatus, errorThrown) {
          sentryRequestHeaderObj = (request.getResponseHeader('X-Request-ID'));
          
          Sentry.configureScope(function(scope) {
            scope.setLevel('error');
            scope.setTag("Request-Id", sentryRequestHeaderObj);
          });

          Sentry.captureMessage('Error in ajax request, Request-Id '+sentryRequestHeaderObj+" Function name: getCartItems");
          
        },
        complete: function (data, textStatus, request) {
          
        },
        url: getCartItemsUrl,
        statusCode: {
            200: function (data) {
              isGetCartItemFunctionCalled = true;
             
              if(!($.isEmptyObject(data))){
                var cartLineItemsArray = data.cart_lineitems;
                var cartLineItemsArrayLength = cartLineItemsArray.length;
                var i;
                for(i=0;i<cartLineItemsArrayLength;i++){
                  var CartLineItemObj = cartLineItemsArray[i];
                  if(!($.isEmptyObject(CartLineItemObj))){
                    
                    
                    var variantArray = CartLineItemObj.variants;
                    var variantsArrayLength = variantArray.length;
                    if(variantsArrayLength>0){
                      var variantObj = variantArray[0];
                      if(!($.isEmptyObject(variantObj))){
                        var cartLineItemProductId = variantObj.product_id;
                        var cartLineItemVariantId = variantObj.inventory_item_id;
                        var lineItemObj = {};
                        lineItemObj["productId"] = cartLineItemProductId;
                        lineItemObj["variantId"] = cartLineItemVariantId;
                        updatedCartLineItemsAray.push(lineItemObj);
                      }
                    }
                  }
                }
              }
            },
            302: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: 'Sorry',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    closeOnCancel: false,
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            401:function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
            },
            403: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: 'Error!',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            400: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: 'Invalid Input!',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });

            },
            500: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: 'Internal Server Error !',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            }
        }
    }).fail(function(data, textStatus, xhr){
    
    console.log(data.getResponseHeader('X-Request-ID'));
        
  });
}


function drawProductDetailDetail(productDetailResponse){
  var sellingPrice = 0;
  var comparePrice = 0;
  var productId = "";
  var variantId = "";
  var handle = "";
  var isProductAddedToCart = false;
  var priceDetailList = "";
  var cartButton = "";
  //   ga code
  var productTitle = "";
  var productSku = "";
  var procuttype = "";
  var brand = "";
  
  if(!($.isEmptyObject(productDetailResponse))){
    
//     ga code
    if(productDetailResponse.title !== null){
      productTitle = productDetailResponse.title;
    } else {
      
      Sentry.configureScope(function(scope) {
        scope.setLevel('debug');
      });
      Sentry.configureScope(function(scope) {
        scope.setTag("Request-Id", sentryRequestHeaderObj);
      });
      Sentry.captureMessage('Title is empty for product handle: '+sentryLogProductHandle);
    }
    
    if(productDetailResponse.product_type !== null){
      procuttype = productDetailResponse.product_type;
    } else {
      
      Sentry.configureScope(function(scope) {
        scope.setLevel('debug');
      });
      Sentry.configureScope(function(scope) {
        scope.setTag("Request-Id", sentryRequestHeaderObj);
      });
      Sentry.captureMessage('Product type is empty for product handle: '+sentryLogProductHandle);
    }
    
    
    if(productDetailResponse.vendor !== null){
      brand = productDetailResponse.vendor;
    } else {
      
      Sentry.configureScope(function(scope) {
        scope.setLevel('debug');
      });
      Sentry.configureScope(function(scope) {
        scope.setTag("Request-Id", sentryRequestHeaderObj);
      });
      Sentry.captureMessage('Product Brand is empty for product handle: '+sentryLogProductHandle);
      
    }
    
    if(productDetailResponse.compare_at_price !== 0){
      comparePrice = (parseFloat(productDetailResponse.compare_at_price)/100).toFixed(2);
    } else {
      
      Sentry.configureScope(function(scope) {
        scope.setLevel('debug');
      });
      Sentry.configureScope(function(scope) {
        scope.setTag("Request-Id", sentryRequestHeaderObj);
      });
      Sentry.captureMessage('Product Compare Price is empty for product handle: '+sentryLogProductHandle);
    }
    
    if(productDetailResponse.price !== 0){
      sellingPrice = (parseFloat(productDetailResponse.price)/100).toFixed(2);
    } else {
      
      Sentry.configureScope(function(scope) {
        scope.setLevel('debug');
      });
      Sentry.configureScope(function(scope) {
        scope.setTag("Request-Id", sentryRequestHeaderObj);
      });
      Sentry.captureMessage('Product price is empty for product handle: '+sentryLogProductHandle);
      
    }
    
    if(productDetailResponse.id !== 0){
       productId = (productDetailResponse.id).toString();
    }
    
    var variantsArray = productDetailResponse.variants;
    
    var variantObj = variantsArray[0];
    variantId = (variantObj.id).toString();
    
    productSku = variantObj.sku;
    
    comparePrice = variantObj.compare_at_price;
    sellingPrice = variantObj.is_variant_in_sale ? variantObj.variant_sale_price : variantObj.price;
    
    if(productDetailResponse.handle !== null){
      var handle = productDetailResponse.handle;
    }
    
    var lineItemAddToCartButtonObj = {};
    lineItemAddToCartButtonObj["product_id"] = (productId).toString();
    lineItemAddToCartButtonObj["variant_id"] = (variantId).toString();
    productAddToCartDetailObj[handle] = lineItemAddToCartButtonObj;
    
    var gaHandlerLineItemObj = {};
    gaHandlerLineItemObj["productId"] = productId;
    gaHandlerLineItemObj["productTitle"] = productTitle;
    gaHandlerLineItemObj["productSku"] = productSku;
    gaHandlerLineItemObj["productType"] = procuttype;
    gaHandlerLineItemObj["sellingPrice"] = sellingPrice;
    gaHandlerLineItemObj["addToCartQuantity"] = 1;
    gaHandlerLineItemObj["productBrand"] = brand;
    gaHandlerLineItemObj["list"] = "collection page result";
    
    gaHandleAddToCartObject[handle] = gaHandlerLineItemObj;
    
    var homePageUrlArray = [];
    var isUrlContainsQueryParamQuestionMarkSlash = pageUrl.indexOf("/?");
    if(isUrlContainsQueryParamQuestionMarkSlash !== -1 ){
      homePageUrlArray = pageUrl.split("/?");
    }
    else{
      var isUrlContainsQuestionmart = pageUrl.indexOf("?");
      if(isUrlContainsQuestionmart !== -1){
        homePageUrlArray = pageUrl.split("?");
      }
    }
    if(pageUrl === homePageUrl || pageUrl === "https://jumkey.com" || pageUrl === "https://www.jumkey.com" || pageUrl === "https://www.jumkey.com/"){
      ga_addImpression(gaHandlerLineItemObj,'Homepage Results');
    }
    else if(homePageUrlArray[0] === "https://jumkey.com" || homePageUrlArray[0] === "https://www.jumkey.com"){
      ga_addImpression(gaHandlerLineItemObj,'Homepage Results');
    }
    else{
      ga_addImpression(gaHandlerLineItemObj,'Collection Results');
    }
    
    
    console.log(comparePrice,sellingPrice)
    if(comparePrice !== sellingPrice){
//       console.log(comparePrice,sellingPrice)
      var comparePriceSpan = "<li style = 'color:#9c9c9c;'><strike><span>Rs. "+comparePrice+"</span></strike></li>";
      var sellingPriceSpan = "<li style = 'font-weight:500'><span>Rs. "+sellingPrice+"</span></li>";
      priceDetailList = "<ul class = 'list-inline priceDetailList'>"+comparePriceSpan+sellingPriceSpan+"</ul>";
    }
    else{
      var sellingPriceSpan = "<li style = 'font-weight:500' ><span>Rs. "+sellingPrice+"</span></li>";
      priceDetailList = "<ul class = 'list-inline priceDetailList'>"+sellingPriceSpan+"</ul>";
    }
    
    
    var localStorageProdId = "cart_product_id"+productId;
    var localStorageVariantId = "cart_variant_id"+variantId;
    var isProductIdExists = localStorage.hasOwnProperty(localStorageProdId);
    var isVariantIdExists = localStorage.hasOwnProperty(localStorageVariantId);
    
    if(isProductIdExists === true && isVariantIdExists === true){
      isProductAddedToCart = true;
    }
    else{
      isProductAddedToCart = false;
    }
    
    
// this if condition is to check customer login and cart product and will draw cart button
    if(isProductAddedToCart === true && isCustomerLoggedIn === true){
//       button to move to cart
      cartButton = "<button type = 'button' class ='btn btn-added' id ='moveToCart' >"+cartIcon+" go to cart</button>";
    }
    else if(isProductAddedToCart === false && isCustomerLoggedIn === true){
//       button to add to cart 
//       console.log(variantId,"add to cart",productSku)
      cartButton = "<button disabled='disabled' type = 'button' class ='btn btn-addToCart addToCart' role="+handle+" id =addToCart_"+variantId+" >"+cartIcon+" ADD TO CART</button>";
//       cartButton = "<button type = 'button' class ='btn btn-addToCart addToCart' role="+handle+" id ="+variantId+" >"+cartIcon+" ADD TO CART</button>";
    }
    else{
//       button to redirection to login page
      cartButton = "<button type = 'button' class ='btn btn-addToCart' id ='redirectToLogin' >"+cartIcon+" ADD TO CART</button>";
    }
    
    
    var updatedBrandName = (brand.split(" ").join("_")).toUpperCase();
    
    if (updatedBrandName === "PRADE_JEWELS") {
      cartButton = "<button type = 'button' class ='btn btn-added' onclick='window.fcWidget.open();window.fcWidget.show();' id='invokeChat'>ENQUIRE NOW</button>";
    }
    
    
    var collectionDiv = 
        "<div class='customAddToCart' id = "+handle+" >"+
        	"<div class='priceDetailDiv'>"+priceDetailList+"</div>"+
        "<div class='cartButtonDiv' style='display:none' id = cartButtonDiv_"+handle+" >"+cartButton+"</div>"+
    	"</div>";
    $('#customAddtoCaratButtonDiv_'+handle).html(collectionDiv);
  } else{
    
    Sentry.configureScope(function(scope) {
      scope.setLevel('fatal');
    });
    
    Sentry.configureScope(function(scope) {
      scope.setTag("Request-Id", sentryRequestHeaderObj);
    });
    
//     Sentry.captureMessage('Add to cart button is not visible handle:'+sentryLogProductHandle+"Response:"+sentryResponse);

  }
}

// fb move to wishlist 
function getWishListObj(productHandle){
  var wishlistObj = gaHandleAddToCartObject[productHandle];
  fb_moveToWishList(wishlistObj,"Collection Results");
}


// click event is to get product handle and calls add to cart function
$(document).on('click','.addToCart',function(){
   var productHandle = $(this).attr('role');
   var zipImage = "<img style= 'height:34px; width: 40px' class='center-block' src='https://cdn.shopify.com/s/files/1/0820/8999/files/addtoCart.gif?9307453900694986560' />";
   var updatedCartButton = "<button disabled='disabled' type = 'button' class ='btn btn-adding-to-cart' >"+zipImage+"</button>";
  
   var cartButtonDivId = "cartButtonDiv_"+productHandle;
  
  $('#'+cartButtonDivId).html(updatedCartButton);
  
  checkAddToCart(productHandle);
});

function checkAddToCart(productHandle){
  var productDetailObj = productAddToCartDetailObj[productHandle];
  var productId = productDetailObj.product_id;
  var variantId = productDetailObj.variant_id;
  var localStorageProdId = "cart_product_id"+productId;
  var localStorageVariantId = "cart_variant_id"+variantId;
  var isProductIdExists = localStorage.hasOwnProperty(localStorageProdId);
  var isVariantIdExists = localStorage.hasOwnProperty(localStorageVariantId);
  if(isProductIdExists === true && isVariantIdExists === true){
    updateCartButton(productHandle);
  }
  else{
    collectionAddToCart(productHandle);
  }
}

// function to add a product to cart
function collectionAddToCart(productHandle){
  var productDetailObj = productAddToCartDetailObj[productHandle];
  var gaProductDetailObj = gaHandleAddToCartObject[productHandle];
  
  var homePageUrlArray;
  var isUrlContainsQueryParamQuestionMarkSlash = pageUrl.indexOf("/?");
  if(isUrlContainsQueryParamQuestionMarkSlash !== -1 ){
    homePageUrlArray = pageUrl.split("/?");
  }
  else{
    var isUrlContainsQuestionmart = pageUrl.indexOf("?");
    if(isUrlContainsQuestionmart !== -1){
      homePageUrlArray = pageUrl.split("?");
    }
  }
  
//   ga code
  if(pageUrl === homePageUrl || pageUrl === "https://jumkey.com" || pageUrl === "https://www.jumkey.com" || pageUrl === "https://www.jumkey.com/"){
    ga_addToCart(gaProductDetailObj,'Homepage Results');
  }
  else if(pageUrl.indexOf("collections") !== -1 && pageUrl.indexOf("products") === -1){
    ga_addToCart(gaProductDetailObj,'Collection Results');
  }
  
  fb_addToCart(gaProductDetailObj,"Collection Results");
  
  var productId = productDetailObj.product_id;
  var variantId = productDetailObj.variant_id;
  var addToCartUrl = cartBaseUrl+addToCartEndPoint+customerId;
  var jsonString = JSON.stringify(productDetailObj);
  
  $.ajax({
        type: 'POST',
        timeout: ajaxCallTimeout,
        dataType: 'json',
        contentType: 'application/json',
        error: function (request, textStatus, errorThrown) {
          sentryRequestHeaderObj = (request.getResponseHeader('X-Request-ID'));
          
          Sentry.configureScope(function(scope) {
            scope.setLevel('error');
            scope.setTag("Request-Id", sentryRequestHeaderObj);
          });

          Sentry.captureMessage('Error in ajax request, Request-Id '+sentryRequestHeaderObj +" Function name: collectionAddToCart");
          
            var updatedCartButton = "<button type = 'button' class ='btn btn-addToCart addToCart' id ="+productHandle+" >"+cartIcon+" ADD TO CART</button>";
  
  			var cartButtonDivId = "cartButtonDiv_"+productHandle;
  
  			$('#'+cartButtonDivId).html(updatedCartButton);	
        },
        url: addToCartUrl,
        headers: getV3Header(),
        data:jsonString,
        beforeSend: function () {
        },
        complete: function (data, textStatus, request) {
          
        },
        statusCode: {
            201: function (data) {
              
              if(typeof ("storage") !== "undefined"){
                localStorage.setItem("cart_variant_id"+variantId,variantId);
                localStorage.setItem("cart_product_id"+productId,productId);
              }
              
              updateCartButton(productHandle);
              updateCartCount(customerId);
              
            },
            302: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            403: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            400: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
          401: function(){
            
          },
          416: function(data){
            var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
          },
          412: function(){
            updateCartButton(productHandle);
          },
            422: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            500: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            }
        }
    }).fail(function(data, textStatus, xhr){
    
    console.log(data.getResponseHeader('X-Request-ID'));
       
  });
  
}

// function to update cart count 
function updateCartCount(customerId){
  updateCartCount(customerId);
}

// function to update cart button from add to cart to added to cart
function updateCartButton(productHandle){
  
  var updatedCartButton = "<button type = 'button' class ='btn btn-added' id ='moveToCart' >"+cartIcon+" go to cart</button>";
  
  var cartButtonDivId = "cartButtonDiv_"+productHandle;
  
  $('#'+cartButtonDivId).html(updatedCartButton);
}

$(document).on('click','#moveToCart',function(){
  location.assign("https://jumkey.myshopify.com/pages/cart");
});

// click event is to redirect to the login page
// if customer is not loged in then it will redirect to the login page
$(document).on('click','#redirectToLogin',function(){
  location.assign("https://jumkey.myshopify.com/account/login");
});


$(document).on('click','#invokeChat',function(){
  window.fcWidget.open();window.fcWidget.show();
  logCustomerDetail(sentryLogProductHandle)
});